module.exports = __webpack_public_path__ + "static/media/spider-black-widow.ce4159b4.svg";